<p-confirmDialog />

<div class="space-y-4">
  <!-- Tab switch -->
  <div class="flex gap-1 p-1 bg-gray-100 dark:bg-gray-800 rounded-xl w-full sm:w-fit">
    <button
      type="button"
      (click)="switchTab('categories')"
      [class]="
        activeTab === 'categories'
          ? 'flex-1 sm:flex-none px-5 py-2 rounded-lg text-sm font-medium bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 shadow-sm transition-all'
          : 'flex-1 sm:flex-none px-5 py-2 rounded-lg text-sm font-medium text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 transition-all'
      "
    >
      <i class="pi pi-tag mr-1.5"></i>
      {{ 'CATEGORIES.TAB' | translate }}
    </button>
    <button
      type="button"
      (click)="switchTab('units')"
      [class]="
        activeTab === 'units'
          ? 'flex-1 sm:flex-none px-5 py-2 rounded-lg text-sm font-medium bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 shadow-sm transition-all'
          : 'flex-1 sm:flex-none px-5 py-2 rounded-lg text-sm font-medium text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 transition-all'
      "
    >
      <i class="pi pi-box mr-1.5"></i>
      {{ 'UNITS.TAB' | translate }}
    </button>
    <button
      type="button"
      (click)="switchTab('attributes')"
      [class]="
        activeTab === 'attributes'
          ? 'flex-1 sm:flex-none px-5 py-2 rounded-lg text-sm font-medium bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 shadow-sm transition-all'
          : 'flex-1 sm:flex-none px-5 py-2 rounded-lg text-sm font-medium text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 transition-all'
      "
    >
      <i class="pi pi-sliders-h mr-1.5"></i>
      {{ 'VARIANT_ATTRS.TAB' | translate }}
    </button>
  </div>

  <!-- ═══════════════ Umumiy search + filter + create panel ═══════════════ -->
  <div class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-4">
    <div class="flex flex-col sm:flex-row gap-3">
      @if (activeTab === 'categories') {
        <input
          pInputText
          [(ngModel)]="catSearch"
          [placeholder]="'CATEGORIES.SEARCH_PLACEHOLDER' | translate"
          class="flex-1 min-w-0"
          (keyup.enter)="onCatSearch()"
        />
      } @else if (activeTab === 'units') {
        <input
          pInputText
          [(ngModel)]="unitSearch"
          [placeholder]="'UNITS.SEARCH_PLACEHOLDER' | translate"
          class="flex-1 min-w-0"
          (keyup.enter)="onUnitSearch()"
        />
      } @else {
        <input
          pInputText
          [(ngModel)]="attrSearch"
          [placeholder]="'VARIANT_ATTRS.SEARCH_PLACEHOLDER' | translate"
          class="flex-1 min-w-0"
          (keyup.enter)="onAttrSearch()"
        />
      }
      <p-select
        [options]="storeTypes()"
        optionLabel="name"
        optionValue="id"
        [(ngModel)]="storeTypeFilter"
        [placeholder]="'COMMON.FILTER.STORE_TYPE_ALL' | translate"
        [showClear]="true"
        appendTo="body"
        styleClass="w-full sm:w-48"
        (onChange)="onStoreTypeFilter()"
        (onClear)="onStoreTypeFilter()"
      />
      <p-button
        [label]="'COMMON.SEARCH' | translate"
        icon="pi pi-search"
        severity="secondary"
        [loading]="catLoading() || unitLoading() || attrLoading()"
        (onClick)="
          activeTab === 'categories'
            ? onCatSearch()
            : activeTab === 'units'
              ? onUnitSearch()
              : onAttrSearch()
        "
        styleClass="shrink-0"
      />
      <p-button
        [label]="
          (activeTab === 'categories'
            ? 'CATEGORIES.ADD_BTN'
            : activeTab === 'units'
              ? 'UNITS.ADD_BTN'
              : 'VARIANT_ATTRS.ADD_BTN'
          ) | translate
        "
        icon="pi pi-plus"
        styleClass="shrink-0 whitespace-nowrap"
        (onClick)="
          activeTab === 'categories'
            ? openCreateCat()
            : activeTab === 'units'
              ? openCreateUnit()
              : openCreateAttr()
        "
      />
    </div>
  </div>

  <!-- ═══════════════ CATEGORIES TAB ═══════════════ -->
  @if (activeTab === 'categories') {
    <!-- Table -->
    <div
      class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 shadow-sm overflow-hidden"
    >
      <div class="overflow-x-auto">
        <p-table
          [value]="categories()"
          [loading]="catLoading()"
          [paginator]="true"
          [rows]="20"
          [rowsPerPageOptions]="[10, 20, 50]"
          styleClass="p-datatable-sm"
          [rowHover]="true"
          [tableStyle]="{ 'min-width': '30rem' }"
        >
          <ng-template pTemplate="header">
            <tr>
              <th class="w-8">#</th>
              <th>{{ 'CATEGORIES.COL.NAME' | translate }}</th>
              <th class="hidden md:table-cell">{{ 'CATEGORIES.COL.STORE_TYPE' | translate }}</th>
              <th class="w-28 text-center">{{ 'CATEGORIES.COL.STATUS' | translate }}</th>
              <th class="w-32 hidden sm:table-cell">{{ 'CATEGORIES.COL.CREATED' | translate }}</th>
              <th class="w-24 text-center">{{ 'CATEGORIES.COL.ACTIONS' | translate }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-cat let-rowIndex="rowIndex">
            <tr>
              <td class="text-gray-400 text-xs">{{ rowIndex + 1 }}</td>
              <td>
                <span class="font-medium text-gray-900 dark:text-gray-100">{{ cat.name }}</span>
              </td>
              <td class="hidden md:table-cell">
                @if (cat.storeTypeName) {
                  <span
                    class="inline-flex items-center gap-1 text-xs font-medium px-2 py-0.5 rounded-full bg-indigo-50 text-indigo-700 dark:bg-indigo-900/30 dark:text-indigo-300"
                  >
                    <i class="pi pi-tag text-[10px]"></i>
                    {{ cat.storeTypeName }}
                  </span>
                } @else {
                  <span class="text-xs text-gray-400">—</span>
                }
              </td>
              <td class="text-center">
                <p-tag
                  [value]="(cat.isActive ? 'COMMON.ACTIVE' : 'COMMON.INACTIVE') | translate"
                  [severity]="cat.isActive ? 'success' : 'secondary'"
                />
              </td>
              <td class="text-sm text-gray-500 dark:text-gray-400 hidden sm:table-cell">
                {{ formatDate(cat.createdAt) }}
              </td>
              <td>
                <div class="flex items-center justify-center gap-1">
                  <p-button
                    icon="pi pi-pencil"
                    [rounded]="true"
                    [text]="true"
                    severity="secondary"
                    size="small"
                    [pTooltip]="'COMMON.EDIT' | translate"
                    tooltipPosition="top"
                    (onClick)="openEditCat(cat)"
                  />
                  <p-button
                    icon="pi pi-trash"
                    [rounded]="true"
                    [text]="true"
                    severity="danger"
                    size="small"
                    [pTooltip]="'COMMON.DELETE' | translate"
                    tooltipPosition="top"
                    (onClick)="confirmDeleteCat(cat)"
                  />
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="6" class="text-center py-12 text-gray-400">
                <i class="pi pi-tag text-3xl mb-2 block"></i>
                {{ 'CATEGORIES.EMPTY' | translate }}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  }

  <!-- ═══════════════ UNITS TAB ═══════════════ -->
  @if (activeTab === 'units') {
    <!-- Table -->
    <div
      class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 shadow-sm overflow-hidden"
    >
      <div class="overflow-x-auto">
        <p-table
          [value]="units()"
          [loading]="unitLoading()"
          [paginator]="true"
          [rows]="20"
          [rowsPerPageOptions]="[10, 20, 50]"
          styleClass="p-datatable-sm"
          [rowHover]="true"
          [tableStyle]="{ 'min-width': '24rem' }"
        >
          <ng-template pTemplate="header">
            <tr>
              <th class="w-8">#</th>
              <th>{{ 'UNITS.COL.NAME' | translate }}</th>
              <th class="hidden md:table-cell">{{ 'UNITS.COL.STORE_TYPE' | translate }}</th>
              <th class="w-28 text-center">{{ 'UNITS.COL.STATUS' | translate }}</th>
              <th class="w-24 text-center">{{ 'UNITS.COL.ACTIONS' | translate }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-unit let-rowIndex="rowIndex">
            <tr>
              <td class="text-gray-400 text-xs">{{ rowIndex + 1 }}</td>
              <td>
                <span class="font-medium text-gray-900 dark:text-gray-100">{{ unit.name }}</span>
              </td>
              <td class="hidden md:table-cell">
                @if (unit.storeTypeName) {
                  <span
                    class="inline-flex items-center gap-1 text-xs font-medium px-2 py-0.5 rounded-full bg-indigo-50 text-indigo-700 dark:bg-indigo-900/30 dark:text-indigo-300"
                  >
                    <i class="pi pi-tag text-[10px]"></i>
                    {{ unit.storeTypeName }}
                  </span>
                } @else {
                  <span class="text-xs text-gray-400">—</span>
                }
              </td>
              <td class="text-center">
                <p-tag
                  [value]="(unit.isActive ? 'COMMON.ACTIVE' : 'COMMON.INACTIVE') | translate"
                  [severity]="unit.isActive ? 'success' : 'secondary'"
                />
              </td>
              <td>
                <div class="flex items-center justify-center gap-1">
                  <p-button
                    icon="pi pi-pencil"
                    [rounded]="true"
                    [text]="true"
                    severity="secondary"
                    size="small"
                    [pTooltip]="'COMMON.EDIT' | translate"
                    tooltipPosition="top"
                    (onClick)="openEditUnit(unit)"
                  />
                  <p-button
                    icon="pi pi-trash"
                    [rounded]="true"
                    [text]="true"
                    severity="danger"
                    size="small"
                    [pTooltip]="'COMMON.DELETE' | translate"
                    tooltipPosition="top"
                    (onClick)="confirmDeleteUnit(unit)"
                  />
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="5" class="text-center py-12 text-gray-400">
                <i class="pi pi-box text-3xl mb-2 block"></i>
                {{ 'UNITS.EMPTY' | translate }}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  }

  <!-- ═══════════════ ATTRIBUTES TAB ═══════════════ -->
  @if (activeTab === 'attributes') {
    <!-- Table -->
    <div
      class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 shadow-sm overflow-hidden"
    >
      <div class="overflow-x-auto">
        <p-table
          [value]="attributes()"
          [loading]="attrLoading()"
          [paginator]="true"
          [rows]="20"
          [rowsPerPageOptions]="[10, 20, 50]"
          styleClass="p-datatable-sm"
          [rowHover]="true"
          [tableStyle]="{ 'min-width': '36rem' }"
        >
          <ng-template pTemplate="header">
            <tr>
              <th class="w-8">#</th>
              <th class="w-48">{{ 'VARIANT_ATTRS.COL.NAME' | translate }}</th>
              <th class="hidden md:table-cell">{{ 'VARIANT_ATTRS.COL.STORE_TYPE' | translate }}</th>
              <th>{{ 'VARIANT_ATTRS.COL.VALUES' | translate }}</th>
              <th class="w-28 text-center">{{ 'VARIANT_ATTRS.COL.STATUS' | translate }}</th>
              <th class="w-24 text-center">{{ 'VARIANT_ATTRS.COL.ACTIONS' | translate }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-attr let-rowIndex="rowIndex">
            <tr>
              <td class="text-gray-400 text-xs">{{ rowIndex + 1 }}</td>
              <td>
                <span class="font-medium text-gray-900 dark:text-gray-100">{{ attr.name }}</span>
              </td>
              <td class="hidden md:table-cell">
                @if (attr.storeTypeName) {
                  <span
                    class="inline-flex items-center gap-1 text-xs font-medium px-2 py-0.5 rounded-full bg-indigo-50 text-indigo-700 dark:bg-indigo-900/30 dark:text-indigo-300"
                  >
                    <i class="pi pi-tag text-[10px]"></i>
                    {{ attr.storeTypeName }}
                  </span>
                } @else {
                  <span class="text-xs text-gray-400">—</span>
                }
              </td>
              <td>
                <div class="flex flex-wrap gap-1">
                  @for (v of activeValuesLabel(attr); track v.id) {
                    <p-tag [value]="v.value" severity="secondary" />
                  } @empty {
                    <span class="text-xs text-gray-400">{{
                      'VARIANT_ATTRS.NO_VALUES' | translate
                    }}</span>
                  }
                </div>
              </td>
              <td class="text-center">
                <p-tag
                  [value]="(attr.isActive ? 'COMMON.ACTIVE' : 'COMMON.INACTIVE') | translate"
                  [severity]="attr.isActive ? 'success' : 'secondary'"
                />
              </td>
              <td>
                <div class="flex items-center justify-center gap-1">
                  <p-button
                    icon="pi pi-pencil"
                    [rounded]="true"
                    [text]="true"
                    severity="secondary"
                    size="small"
                    [pTooltip]="'COMMON.EDIT' | translate"
                    tooltipPosition="top"
                    (onClick)="openEditAttr(attr)"
                  />
                  <p-button
                    icon="pi pi-trash"
                    [rounded]="true"
                    [text]="true"
                    severity="danger"
                    size="small"
                    [pTooltip]="'COMMON.DELETE' | translate"
                    tooltipPosition="top"
                    (onClick)="confirmDeleteAttr(attr)"
                  />
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="6" class="text-center py-12 text-gray-400">
                <i class="pi pi-sliders-h text-3xl mb-2 block"></i>
                {{ 'VARIANT_ATTRS.EMPTY' | translate }}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  }
</div>

<!-- Category Create/Edit Dialog -->
<p-dialog
  [(visible)]="catDialogVisible"
  [header]="(isCatEdit ? 'CATEGORIES.EDIT_TITLE' : 'CATEGORIES.CREATE_TITLE') | translate"
  [modal]="true"
  [closable]="true"
  [style]="{ width: 'min(420px, 95vw)' }"
  (onHide)="closeCatDialog()"
>
  <div class="flex flex-col gap-4 pt-2">
    <div class="flex flex-col gap-1.5">
      <label for="cat-name" class="text-sm font-medium text-gray-700 dark:text-gray-300">
        {{ 'CATEGORIES.FORM.NAME' | translate }} <span class="text-red-500">*</span>
      </label>
      <input
        id="cat-name"
        pInputText
        [(ngModel)]="catForm.name"
        [placeholder]="'CATEGORIES.FORM.NAME_PLACEHOLDER' | translate"
        class="w-full"
        (keyup.enter)="saveCat()"
      />
    </div>

    @if (!isCatEdit && storePick.visible()) {
      <div class="flex flex-col gap-1.5">
        <label for="" class="text-sm font-medium text-gray-700 dark:text-gray-300">
          {{ 'CATEGORIES.FORM.STORE' | translate }}
        </label>
        <p-select
          [options]="stores()"
          optionLabel="name"
          optionValue="id"
          [(ngModel)]="catForm.storeId"
          [placeholder]="'CATEGORIES.FORM.STORE_PLACEHOLDER' | translate"
          [showClear]="true"
          appendTo="body"
          styleClass="w-full"
        />
        @if (selectedStoreTypeName()) {
          <p class="text-xs text-indigo-600 dark:text-indigo-400 flex items-center gap-1">
            <i class="pi pi-check-circle"></i>
            {{ 'CATEGORIES.FORM.STORE_TYPE_HINT' | translate }}:
            <strong>{{ selectedStoreTypeName() }}</strong>
          </p>
        } @else {
          <p class="text-xs text-gray-400">{{ 'CATEGORIES.FORM.STORE_HINT' | translate }}</p>
        }
      </div>
    }

    @if (isCatEdit) {
      <div
        class="flex items-center justify-between rounded-lg border border-gray-200 dark:border-gray-700 p-3"
      >
        <div>
          <p class="text-sm font-medium text-gray-700 dark:text-gray-300">
            {{ 'CATEGORIES.FORM.ACTIVE' | translate }}
          </p>
          <p class="text-xs text-gray-400 mt-0.5">
            {{ 'CATEGORIES.FORM.ACTIVE_HINT' | translate }}
          </p>
        </div>
        <p-toggleswitch [(ngModel)]="catForm.isActive" />
      </div>
    }
  </div>
  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-2">
      <p-button
        [label]="'COMMON.CANCEL' | translate"
        severity="secondary"
        [text]="true"
        (onClick)="closeCatDialog()"
      />
      <p-button
        [label]="(isCatEdit ? 'COMMON.UPDATE' : 'COMMON.CREATE') | translate"
        [loading]="catSaving"
        (onClick)="saveCat()"
      />
    </div>
  </ng-template>
</p-dialog>

<!-- Unit Create/Edit Dialog -->
<p-dialog
  [(visible)]="unitDialogVisible"
  [header]="(isUnitEdit ? 'UNITS.EDIT_TITLE' : 'UNITS.CREATE_TITLE') | translate"
  [modal]="true"
  [closable]="true"
  [style]="{ width: 'min(420px, 95vw)' }"
  (onHide)="closeUnitDialog()"
>
  <div class="flex flex-col gap-4 pt-2">
    <div class="flex flex-col gap-1.5">
      <label for="unit-name" class="text-sm font-medium text-gray-700 dark:text-gray-300">
        {{ 'UNITS.FORM.NAME' | translate }} <span class="text-red-500">*</span>
      </label>
      <input
        id="unit-name"
        pInputText
        [(ngModel)]="unitForm.name"
        [placeholder]="'UNITS.FORM.NAME_PLACEHOLDER' | translate"
        class="w-full"
        (keyup.enter)="saveUnit()"
      />
    </div>

    @if (!isUnitEdit && storePick.visible()) {
      <div class="flex flex-col gap-1.5">
        <label for="" class="text-sm font-medium text-gray-700 dark:text-gray-300">
          {{ 'UNITS.FORM.STORE' | translate }}
        </label>
        <p-select
          [options]="stores()"
          optionLabel="name"
          optionValue="id"
          [(ngModel)]="unitForm.storeId"
          [placeholder]="'UNITS.FORM.STORE_PLACEHOLDER' | translate"
          [showClear]="true"
          appendTo="body"
          styleClass="w-full"
        />
        @if (selectedUnitStoreTypeName()) {
          <p class="text-xs text-indigo-600 dark:text-indigo-400 flex items-center gap-1">
            <i class="pi pi-check-circle"></i>
            {{ 'CATEGORIES.FORM.STORE_TYPE_HINT' | translate }}:
            <strong>{{ selectedUnitStoreTypeName() }}</strong>
          </p>
        } @else {
          <p class="text-xs text-gray-400">{{ 'UNITS.FORM.STORE_HINT' | translate }}</p>
        }
      </div>
    }

    @if (isUnitEdit) {
      <div
        class="flex items-center justify-between rounded-lg border border-gray-200 dark:border-gray-700 p-3"
      >
        <div>
          <p class="text-sm font-medium text-gray-700 dark:text-gray-300">
            {{ 'UNITS.FORM.ACTIVE' | translate }}
          </p>
          <p class="text-xs text-gray-400 mt-0.5">{{ 'UNITS.FORM.ACTIVE_HINT' | translate }}</p>
        </div>
        <p-toggleswitch [(ngModel)]="unitForm.isActive" />
      </div>
    }
  </div>
  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-2">
      <p-button
        [label]="'COMMON.CANCEL' | translate"
        severity="secondary"
        [text]="true"
        (onClick)="closeUnitDialog()"
      />
      <p-button
        [label]="(isUnitEdit ? 'COMMON.UPDATE' : 'COMMON.CREATE') | translate"
        [loading]="unitSaving"
        (onClick)="saveUnit()"
      />
    </div>
  </ng-template>
</p-dialog>

<!-- Variant Attribute Create/Edit Dialog -->
<p-dialog
  [(visible)]="attrDialogVisible"
  [header]="(isAttrEdit ? 'VARIANT_ATTRS.EDIT_TITLE' : 'VARIANT_ATTRS.CREATE_TITLE') | translate"
  [modal]="true"
  [closable]="true"
  [style]="{ width: 'min(520px, 95vw)' }"
  (onHide)="closeAttrDialog()"
>
  <div class="flex flex-col gap-4 pt-2">
    <div class="flex flex-col gap-1.5">
      <label for="attr-name" class="text-sm font-medium text-gray-700 dark:text-gray-300">
        {{ 'VARIANT_ATTRS.FORM.NAME' | translate }} <span class="text-red-500">*</span>
      </label>
      <input
        id="attr-name"
        pInputText
        [(ngModel)]="attrForm.name"
        [placeholder]="'VARIANT_ATTRS.FORM.NAME_PLACEHOLDER' | translate"
        class="w-full"
      />
    </div>

    @if (!isAttrEdit && storePick.visible()) {
      <div class="flex flex-col gap-1.5">
        <label for="" class="text-sm font-medium text-gray-700 dark:text-gray-300">
          {{ 'VARIANT_ATTRS.FORM.STORE' | translate }}
        </label>
        <p-select
          [options]="stores()"
          optionLabel="name"
          optionValue="id"
          [(ngModel)]="attrForm.storeId"
          [placeholder]="'VARIANT_ATTRS.FORM.STORE_PLACEHOLDER' | translate"
          [showClear]="true"
          appendTo="body"
          styleClass="w-full"
        />
        @if (selectedAttrStoreTypeName()) {
          <p class="text-xs text-indigo-600 dark:text-indigo-400 flex items-center gap-1">
            <i class="pi pi-check-circle"></i>
            {{ 'CATEGORIES.FORM.STORE_TYPE_HINT' | translate }}:
            <strong>{{ selectedAttrStoreTypeName() }}</strong>
          </p>
        } @else {
          <p class="text-xs text-gray-400">{{ 'VARIANT_ATTRS.FORM.STORE_HINT' | translate }}</p>
        }
      </div>
    }

    <div class="flex flex-col gap-2">
      <div class="flex items-center justify-between">
        <label for="" class="text-sm font-medium text-gray-700 dark:text-gray-300">
          {{ 'VARIANT_ATTRS.FORM.VALUES' | translate }}
        </label>
        <p-button
          [label]="'VARIANT_ATTRS.FORM.ADD_VALUE_ROW' | translate"
          icon="pi pi-plus"
          severity="secondary"
          [text]="true"
          size="small"
          (onClick)="addAttrValueRow()"
        />
      </div>
      @for (row of attrForm.values; track $index) {
        <div class="flex items-center gap-2">
          <input
            pInputText
            [(ngModel)]="row.value"
            [placeholder]="'VARIANT_ATTRS.FORM.VALUE_PLACEHOLDER' | translate"
            class="flex-1"
          />
          <p-button
            icon="pi pi-times"
            [rounded]="true"
            [text]="true"
            severity="danger"
            size="small"
            (onClick)="removeAttrValueRow($index)"
          />
        </div>
      }
    </div>

    @if (isAttrEdit) {
      <div
        class="flex items-center justify-between rounded-lg border border-gray-200 dark:border-gray-700 p-3"
      >
        <div>
          <p class="text-sm font-medium text-gray-700 dark:text-gray-300">
            {{ 'VARIANT_ATTRS.FORM.ACTIVE' | translate }}
          </p>
          <p class="text-xs text-gray-400 mt-0.5">
            {{ 'VARIANT_ATTRS.FORM.ACTIVE_HINT' | translate }}
          </p>
        </div>
        <p-toggleswitch [(ngModel)]="attrForm.isActive" />
      </div>
    }
  </div>
  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-2">
      <p-button
        [label]="'COMMON.CANCEL' | translate"
        severity="secondary"
        [text]="true"
        (onClick)="closeAttrDialog()"
      />
      <p-button
        [label]="(isAttrEdit ? 'COMMON.UPDATE' : 'COMMON.CREATE') | translate"
        [loading]="attrSaving"
        (onClick)="saveAttr()"
      />
    </div>
  </ng-template>
</p-dialog>
